export default class AvailablesModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
